
import { defineComponent } from "vue";
import { wrapLoading } from "../../../utils/wrap_loading";

export default defineComponent({
  name: "ExcelButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    disabledMessage: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const handleClick = () => {
      wrapLoading(async () => {
        if (!props.disabled) {
          emit("click");
        }
      });
    };

    return {
      handleClick
    };
  }
});
